module.exports = __webpack_public_path__ + "img/image_news_Tiny_Tan_collabo01.510ce232.png";